import { createContext, useContext, RefObject, Dispatch, SetStateAction } from 'react'

import { MobileTab } from 'modules/transmission/types'
import { TransmissionInfo, OnFireLanguageResponse } from '../types'
import { EMPTY_TRANSMISSION_INFO } from 'modules/transmission/constants'
import { HTMLHotModalElement } from 'modules/transmission/components/configMenuMobile'

export interface TransmissionState {
  transmissionCode: string,
  setTransmissionCode: (value: string) => void,
  activeTab?: MobileTab,
  setActiveTab: (value: MobileTab | undefined) => void,
  transmissionData: TransmissionInfo,
  setTransmissionData: Dispatch<SetStateAction<TransmissionInfo>>,
  loading: boolean,
  setLoading: (value: boolean) => void,
  isPrivate: boolean,
  isOnFire: boolean,
  openLanguageModal: () => void,
  onFireLanguages?: OnFireLanguageResponse[],
  setOnFireLanguages: (value: OnFireLanguageResponse[]) => void,
  showOnfireLanguages: boolean,
  isClub: boolean,
  setIsClub: Dispatch<SetStateAction<boolean>>,
  languageModalRef?: RefObject<HTMLHotModalElement>,
  isHotmartProvider: boolean
}

export const INITIAL_STATE: TransmissionState = {
  transmissionCode: '',
  setTransmissionCode: () => void 0,
  activeTab: MobileTab.CHAT,
  setActiveTab: () => void 0,
  transmissionData: EMPTY_TRANSMISSION_INFO,
  setTransmissionData: () => void 0,
  loading: true,
  setLoading: () => void 0,
  isPrivate: false,
  isOnFire: false,
  openLanguageModal: () => void 0,
  onFireLanguages: [],
  setOnFireLanguages: () => void 0,
  showOnfireLanguages: false,
  isClub: false,
  setIsClub: () => void 0,
  languageModalRef: void 0,
  isHotmartProvider: false
}

export const TransmissionContext = createContext(INITIAL_STATE)

export const useTransmissionContext = () => useContext(TransmissionContext)
export const useTransmissionDataContext = () => useTransmissionContext().transmissionData
